import { validateField, clearFields, setFieldOptions } from './helpers/form'
import {
	SET_CLIENTREQUEST_SEARCH_DROPDOWN_OPTIONS,
	CLEAR_CLIENTREQUEST_SEARCH_FIELDS,
	VALIDATE_CLIENTREQUEST_SEARCH_FIELD
} from '../../../actions/pages/clientaccount-page'

export function clientRequestSearch(
	state = {
		valid: false,
		fields: [
			{
				name: 'Client',
				value: '',
				errors: [],
				rules: {
					title: 'Client'
				},
				placeholder: 'All clients',
				options: []
			}
		]
	},
	action
) {
	switch (action.type) {
		case SET_CLIENTREQUEST_SEARCH_DROPDOWN_OPTIONS:
			return setFieldOptions(state, 'Client', action.productionContentOwners);
		case VALIDATE_CLIENTREQUEST_SEARCH_FIELD:
			return validateField(state, action);
		case CLEAR_CLIENTREQUEST_SEARCH_FIELDS:{
			return clearFields(state);
		}
		default:
			return state
	}
}